<template>
  <div>
    <el-dialog :visible.sync="showmodal" title="Update Status" width="30%" @close="$emit('close-modal')">
      <div class="particulars-img-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-12">
              <label for="" class="label">Current Status</label>
              <input type="text" disabled v-model="capStatus" class="input" />
            </div>
            <div class="col-md-12 col-lg-12 col-12">
              <label for="" class="label">Updated By</label>
              <input type="text" disabled v-model="updatedBy" class="input" />
            </div>
            <div class="col-md-12 col-lg-12 col-12">
              <label for="" class="label">Date Last Updated</label>
              <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
                v-model="consolidation.updatedAt" />
            </div>
            <div class="col-md-12 col-lg-12 col-12">
              <label for="" class="label">New status</label>
              <el-select v-model="status" placeholder="Select state">
                <el-option v-for="status in statusList" :key="status" :label="capitalize(status.name)"
                  :value="status.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="button-wrapper">
        <button @click="$emit('close-modal')">Cancel</button>
        <base-button text="Update" :loading="loading" @click="updateStatus" />
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  props: {
    showmodal: Boolean,
    consolidation: Object,
    currentStatus: String,
    lastUpdated: String,
  },
  data() {
    return {
      statusobj: this.getform(),
      status: "",
      loading: false,
      updatedBy:
        this.$store.getters.user.firstname +
        " " +
        this.$store.getters.user.lastname,
      statusList: [
        {
          name: 'Pending Loading',
          value: 'pending_loading',
        },
        {
          name: 'Loading ',
          value: 'loading ',
        },
        {
          name: 'Loading Complete',
          value: 'loading_complete',
        },
        {
          name: 'On-Hold',
          value: 'on-hold',
        },
        {
          name: 'Ready for dispatch',
          value: 'ready_for_dispatch',
        }
      ],
    };
  },
  methods: {
    getform() {
      return {
        newstatus: "",
        message: "",
      };
    },
    async updateStatus() {
      const payload = {
        status: this.status,
      };

      if (this.statusobj.newstatus == 'ready' && this.consolidation.fleet == null && this.consolidation.fleetId == null) {
        this.$emit("close-modal");
        this.generateToast("Cannot be dispatched. Consolidation has not been assigned to Fleet.", "error")
      } else {
        try {
          this.loading = true;

          await this.$_modifyConsolidation(this.consolidation.id, payload);
          this.loading = false;
          this.$emit("refetch-consolidation");
          this.$emit("close-modal");
          this.status = ""
        } catch (error) {
          this.loading = false;
          this.handleError(error);
        }
      }


    },
    capitalize(str) {
      let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1);

      return capitalizedstr;
    },
    // async getStatusList() {
    //   try {
    //     const { data: response } = await this.$_getConsolidationStatusList();
    //     this.statusList = response.data.statusList;
    //   } catch (error) {
    //     this.handleError(error);
    //   }
    // },
  },
  computed: {
    capStatus() {
      return this.capitalize(this.consolidation.status);
    },
  },
  mounted() {
    this.getStatusList();
  },
};
</script>
